/**
 * issue #177: Drive 保存済み完成 PDF の fileId を fileName で引く永続マップ。
 * webViewLink (陳腐化しうる) は持たず、 安定ポインタの fileId のみ持つ (#154 と両立:
 * fileId から files.get で毎回 fresh な link を取得する)。 リンク取得を単一フォルダ探索に
 * 依存させないための堅牢化 (フォルダ移動/名前変更耐性)。
 */
export const DRIVE_PDF_FILEID_KEY = 'omakase-unshi:drive-pdf-fileid';

const MAX_ENTRIES = 50;

function readMap(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(DRIVE_PDF_FILEID_KEY);
  if (!raw) return {};
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, string> = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === 'string') out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

function writeMap(map: Record<string, string>): void {
  if (typeof window === 'undefined') return;
  const entries = Object.entries(map).slice(-MAX_ENTRIES);
  window.localStorage.setItem(DRIVE_PDF_FILEID_KEY, JSON.stringify(Object.fromEntries(entries)));
}

export function setDrivePdfFileId(fileName: string, fileId: string): void {
  if (!fileName || !fileId) return;
  const map = readMap();
  map[fileName] = fileId;
  writeMap(map);
}

export function getDrivePdfFileId(fileName: string): string | null {
  if (!fileName) return null;
  return readMap()[fileName] ?? null;
}

export function clearDrivePdfFileId(fileName: string): void {
  if (!fileName) return;
  const map = readMap();
  if (!(fileName in map)) return;
  delete map[fileName];
  writeMap(map);
}
